module.exports = __webpack_public_path__ + "img/2s.5483dccc.png";